import t from 'shared/utils/translation';

type ValidationValues = {
  period: number | null | undefined | string | null | undefined;
  from: string | null | undefined;
  subject: string;
  body: string;
};

export type Errors = {
  period: string | null | undefined;
  from: string | null | undefined;
  subject: string | null | undefined;
  body: string | null | undefined;
};

export function getErrors(
  values: ValidationValues,
  maxConsentPeriod: number
): Errors {
  const isEmpty = (value: string) =>
    typeof value === 'undefined' || value.length === 0 || !value.trim();

  const isNotNumberOrZero = (num: string | null | number) =>
    // @ts-expect-error - TS2345 - Argument of type 'string | number | null' is not assignable to parameter of type 'string'.
    isNaN(parseInt(num, 10)) || num === '0';

  const userDefined = (userId: string | null | undefined) =>
    typeof userId !== 'undefined';

  const periodErrors = () => {
    const period = values.period;
    if (period === undefined || period === 0 || isNotNumberOrZero(period)) {
      return t('gdpr.consent_extension_email.validation.period');
      // @ts-expect-error - TS2345 - Argument of type 'string | number | null' is not assignable to parameter of type 'string'.
    } else if (maxConsentPeriod && parseInt(period, 10) >= maxConsentPeriod) {
      return t('gdpr.consent_extension_email.validation.maxPeriod', {
        retention_period: maxConsentPeriod,
      });
    }
  };

  const fromErrors = () => {
    if (!userDefined(values.from)) {
      return t('gdpr.consent_extension_email.validation.from');
    }
  };

  const subjectErrors = () => {
    if (isEmpty(values.subject)) {
      return t('gdpr.consent_extension_email.validation.subject');
    }
  };

  const bodyErrors = () => {
    if (isEmpty(values.body)) {
      return t('gdpr.consent_extension_email.validation.body');
    }
  };

  return {
    period: periodErrors(),
    from: fromErrors(),
    subject: subjectErrors(),
    body: bodyErrors(),
  };
}

export function errorsPresent(errors: Errors) {
  return errors.period || errors.body || errors.subject || errors.from;
}
